import { render, staticRenderFns } from "./BulkJobList.vue?vue&type=template&id=f324e0ec&scoped=true&"
import script from "./BulkJobList.vue?vue&type=script&lang=ts&"
export * from "./BulkJobList.vue?vue&type=script&lang=ts&"
import style0 from "./BulkJobList.vue?vue&type=style&index=0&id=f324e0ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f324e0ec",
  null
  
)

export default component.exports